import Products from './products'

export default [
    Products
]